var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgChevronDown = function SvgChevronDown(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.43 8.512C4.49413 8.43717 4.57237 8.37572 4.66026 8.33115C4.74815 8.28658 4.84396 8.25977 4.94221 8.25225C5.04047 8.24473 5.13924 8.25664 5.23289 8.28731C5.32654 8.31798 5.41323 8.36681 5.488 8.431L12 14.012L18.512 8.431C18.6638 8.30912 18.8571 8.25107 19.0509 8.2691C19.2448 8.28713 19.424 8.37984 19.5508 8.52762C19.6775 8.6754 19.7418 8.86668 19.7301 9.06101C19.7184 9.25535 19.6316 9.43751 19.488 9.569L12.488 15.569C12.3521 15.6855 12.179 15.7495 12 15.7495C11.821 15.7495 11.6479 15.6855 11.512 15.569L4.512 9.569C4.36118 9.43951 4.26794 9.25545 4.25275 9.05726C4.23756 8.85907 4.30167 8.66295 4.431 8.512",
    fill: "white"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgChevronDown);
export default ForwardRef;